import React from 'react';
import {facebook, instagram, linkedin, twitter, github, footer, heart} from "../../assets";

function Footer({ data, brand }) {
    return (
        <footer id="footer" className="container-fluid">
            <img src={footer} alt="footer" className="topFooter"/>
            <div className="row">
                <div className="col-xs-12 col-md-4">
                    <div className="socialMedias">
                        {data.socialMedias.gitLink.trim() !== "" && <a id="gitLink" href={data.socialMedias.gitLink}>
                            <img src={github} alt="github" />
                        </a>}
                        {data.socialMedias.twLink.trim() !== "" && <a id="twLink" href={data.socialMedias.twLink}>
                            <img src={twitter} alt="twitter" />
                        </a>}
                        {data.socialMedias.InstaLink.trim() !== "" && <a id="InstaLink" href={data.socialMedias.InstaLink.trim() !== "" && data.socialMedias.InstaLink}>
                            <img src={instagram} alt="instagram"/>
                        </a>}
                        {data.socialMedias.fbLink.trim() !== "" && <a id="fbLink" href={data.socialMedias.fbLink}>
                            <img src={facebook} alt="facebook" />
                        </a>}
                        {data.socialMedias.InLink.trim() !== "" && <a id="InLink" href={data.socialMedias.InLink}>
                            <img src={linkedin} alt="linkedin" />
                        </a>}
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="policy">
                        {data.policy.length > 0 && data.policy.map((e, k) => <a key={k} href={e.link}>{e.title}</a>)}
                    </div>
                    {!data.hideDev && <a href="https://github.com/AimadBahdir" className="dev" target="_blank" rel="noreferrer">
                        <span>Developed with</span>
                        <img src={heart} alt="love"/>
                        <span>By Aimad Bahdir</span>
                    </a>}
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="copyright">
                        {brand.name} © {new Date().getFullYear()}
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
